import Vue from 'vue';
import BonusConvertAhead from '@/components/pages/bonus/components/tables/convert/ahead.vue';
import BonusTableSummary from '@/components/pages/bonus/components/tables/TableSummary.vue';
import moment from 'moment';
export default Vue.extend({
    name: 'bonusConvertTable',
    props: {
        loadError: {
            type: Boolean,
            required: true
        },
        isRetry: {
            type: Boolean,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        hasNext: {
            type: Boolean,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
        isNextPageLoaded: {
            type: Boolean,
            required: true
        },
        totals: {
            type: Object,
            required: true
        },
        totalsAssets: {
            type: Array,
            required: true
        },
        prices: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        dateFrom: null,
        dateTo: null,
        asset: '',
        waitingPage: 0,
        scrollPosition: {
            x: 0,
            y: 0
        },
        isInternalLoad: false
    }),
    methods: {
        onScroll(v) {
            if (v > 0.98) {
                if (this.isRetry || this.loadError)
                    return;
                if (!this.isNextPageLoaded || !this.hasNext || this.waitingPage !== 0)
                    return;
                this.causeLoad(this.currentPage + 1);
            }
        },
        causeLoad(page) {
            if (!this.isNextPageLoaded) {
                this.waitingPage = page;
                return;
            }
            if (page === 1) {
                this.resetScroll();
                this.isInternalLoad = true;
            }
            this.$emit('onLoad', {
                dateFrom: this.dateFrom ? moment(this.dateFrom).toDate() : null,
                dateTo: this.dateTo ? moment(this.dateTo).toDate() : null,
                asset: this.asset,
                currentPage: page
            });
        },
        clearFilters() {
            this.dateFrom = null;
            this.dateTo = null;
            this.asset = '';
            this.causeLoad(1);
        },
        onAssetChange(v) {
            this.asset = v;
            this.causeLoad(1);
        },
        onDateChange({ dateFrom, dateTo }) {
            if (this.dateFrom === dateFrom && this.dateTo === dateTo)
                return;
            this.dateFrom = dateFrom;
            this.dateTo = dateTo;
            this.causeLoad(1);
        },
        resetScroll() {
            this.scrollPosition = { x: 0, y: 0 };
        }
    },
    mounted() {
        this.causeLoad(1);
    },
    watch: {
        isNextPageLoaded(v) {
            if (v && this.waitingPage !== 0) {
                this.causeLoad(this.waitingPage);
                this.waitingPage = 0;
            }
        },
        isRetry(v) {
            if (v && !this.isInternalLoad) {
                this.causeLoad(1);
            }
            else {
                this.isInternalLoad = false;
            }
        }
    },
    components: {
        BonusConvertAhead,
        BonusTableSummary
    }
});
